import { deepCopy } from "../../utils";
import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import { showDangerToast } from "../../validation/ToastContainer";
import { ACTION_CENTRAL_CREDENTIALS_LOADED } from "./AddDeviceModalReducer";
import { securedFetch } from "../../auth/authService";
import { CENTRAL_CREDENTIALS_API, AUTH_API } from "../../vars";

export async function list() {
    const dialogId = await returnSecurityDialogId();
    return securedFetch(`${CENTRAL_CREDENTIALS_API}/list/${dialogId.id}`)
        .then(response => response.json())
        .then(data => {
            data = deepCopy(data);
            store.dispatch(createAction(ACTION_CENTRAL_CREDENTIALS_LOADED)({ centralCredentials: data }));
            return data;
        }).catch(err => {
            showDangerToast(err.message, "Error");
        })
}

export async function returnSecurityDialogId() {
    return fetch(`${AUTH_API}/dialog`, {
        method: 'POST'
    })
        .then(response => response.json())
        .then(dialog => {
            generateClientSecret();
            return dialog;
        })
}

export function generateClientSecret() {
    const maxLength = 6;
    const minLength = 4;

    const secretLength = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;

    const randomString = Math
        .random()
        .toString(36)
        .substring(2, 15) + Math.random()
            .toString(36)
            .substring(2, 15)

    return randomString.substring(0, secretLength);
}